import {
  commerce,
  edtech,
  video,
  saas,
  publishing,
  finance,
  hospitality,
  promoCard,
  cardInner,
  promo,
  title as title_cn,
  overlayLink,
} from "./promo.module.css"

const selectTheme = (theme) => {
  const mapping = {
    commerce: commerce,
    edtech: edtech,
    video: video,
    saas: saas,
    publishing: publishing,
    finance: finance,
    hospitality: hospitality,
    legacy: promoCard,
  }

  return theme ? mapping[theme] : promoCard
}

const Promo = ({ title, label, link }) => {
  const theme = label && label.toLowerCase()
  const className = selectTheme(theme)

  return (
    <article className={className}>
      <div className={cardInner}>
        <div className={promo}>{label}</div>
        <h3 className={title_cn}>
          <a href={link}>{title}</a>
        </h3>
      </div>
      <a href={link} className={overlayLink} aria-hidden>
        {title}
      </a>
    </article>
  )
}

export default Promo
